"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmobilityOnBoardingCasesResponse = exports.BpmRunningCaseData = exports.BPMStepData = void 0;
const tslib_1 = require("tslib");
const base_models_1 = require("@integration/base-models");
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const BPMCaseStep_1 = require("./enums/BPMCaseStep");
const BPMStepStatus_1 = require("./enums/BPMStepStatus");
const ViewCaseDataSerializer_1 = require("./ViewCaseDataSerializer");
class BPMStepData extends base_models_1.Serializable {
}
exports.BPMStepData = BPMStepData;
tslib_1.__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsDefined)(),
    (0, base_models_1.Docs)({
        example: 12,
        description: 'Case ID',
    }),
    tslib_1.__metadata("design:type", Number)
], BPMStepData.prototype, "caseId", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, base_models_1.Docs)({
        example: '2022-01-25T12:39:50.528Z',
        description: 'Start date of the step',
    }),
    tslib_1.__metadata("design:type", String)
], BPMStepData.prototype, "startDate", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, base_models_1.Docs)({
        example: '2022-01-25T12:39:50.528Z',
        description: 'End date of the step. If it is not yet completed, this will be undefined.',
    }),
    tslib_1.__metadata("design:type", String)
], BPMStepData.prototype, "targetDate", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, base_models_1.Docs)({
        example: '2022-01-25T12:39:50.528Z',
        description: 'Last update of the step',
    }),
    tslib_1.__metadata("design:type", String)
], BPMStepData.prototype, "lastUpdate", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, base_models_1.Docs)({
        example: '2022-01-25T12:39:50.528Z',
        description: 'Date when the state was responded by client.',
    }),
    tslib_1.__metadata("design:type", String)
], BPMStepData.prototype, "completionDate", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsEnum)(BPMStepStatus_1.BPMStepStatus),
    (0, base_models_1.Docs)({
        example: BPMStepStatus_1.BPMStepStatus.OFFERED,
        description: `Bpm step status`,
    }),
    tslib_1.__metadata("design:type", String)
], BPMStepData.prototype, "status", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsEnum)(BPMCaseStep_1.BPMCaseStep),
    (0, base_models_1.Docs)({
        example: BPMCaseStep_1.BPMCaseStep.WaitForInstallation,
        description: `Bpm step name`,
    }),
    tslib_1.__metadata("design:type", String)
], BPMStepData.prototype, "name", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, base_models_1.Docs)({ example: base_models_1.SegmentType.HH, description: 'segment' }),
    (0, class_validator_1.IsIn)([base_models_1.SegmentType.HH, base_models_1.SegmentType.SOHO]),
    tslib_1.__metadata("design:type", String)
], BPMStepData.prototype, "segment", void 0);
class BpmRunningCaseData extends base_models_1.Serializable {
}
exports.BpmRunningCaseData = BpmRunningCaseData;
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Type)(() => ViewCaseDataSerializer_1.ViewCaseDataSerializer),
    (0, base_models_1.Docs)({
        example: {
            caseData: {
                emobilityId: '12345',
                accountId: '0123456789',
                state: 'WAITFORDATACOLLECTION',
            },
        },
        description: 'Case data',
    }),
    tslib_1.__metadata("design:type", ViewCaseDataSerializer_1.ViewCaseDataSerializer)
], BpmRunningCaseData.prototype, "caseData", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Type)(() => BPMStepData),
    (0, class_validator_1.ValidateNested)({ each: true }),
    (0, base_models_1.Docs)({
        example: [
            {
                caseId: 12,
                startDate: '2022-01-25T12:39:50.528Z',
                targetDate: '2022-01-25T12:39:50.528Z',
                lastUpdate: '2022-01-25T12:39:50.528Z',
                completionDate: '2022-01-25T12:39:50.528Z',
                status: BPMStepStatus_1.BPMStepStatus.OFFERED,
                name: BPMCaseStep_1.BPMCaseStep.WaitForInstallation,
                segment: base_models_1.SegmentType.HH,
            },
        ],
        description: 'List of steps for the case',
    }),
    tslib_1.__metadata("design:type", Array)
], BpmRunningCaseData.prototype, "steps", void 0);
class EmobilityOnBoardingCasesResponse extends base_models_1.Serializable {
}
exports.EmobilityOnBoardingCasesResponse = EmobilityOnBoardingCasesResponse;
tslib_1.__decorate([
    (0, base_models_1.Docs)({
        example: {
            steps: [
                {
                    caseId: 12,
                    startDate: '2022-01-25T12:39:50.528Z',
                    targetDate: '2022-01-25T12:39:50.528Z',
                    lastUpdate: '2022-01-25T12:39:50.528Z',
                    completionDate: '2022-01-25T12:39:50.528Z',
                    status: BPMStepStatus_1.BPMStepStatus.OFFERED,
                    name: BPMCaseStep_1.BPMCaseStep.WaitForInstallation,
                    segment: base_models_1.SegmentType.HH,
                },
            ],
            caseData: {
                emobilityId: '12345',
                accountId: '0123456789',
                state: 'WAITFORDATACOLLECTION',
            },
        },
        description: 'ChargeCard last step. Only include if there is ChargeCard case available.',
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Type)(() => BpmRunningCaseData),
    tslib_1.__metadata("design:type", BpmRunningCaseData)
], EmobilityOnBoardingCasesResponse.prototype, "chargeCard", void 0);
tslib_1.__decorate([
    (0, base_models_1.Docs)({
        example: {
            steps: [
                {
                    caseId: 12,
                    startDate: '2022-01-25T12:39:50.528Z',
                    targetDate: '2022-01-25T12:39:50.528Z',
                    lastUpdate: '2022-01-25T12:39:50.528Z',
                    completionDate: '2022-01-25T12:39:50.528Z',
                    status: BPMStepStatus_1.BPMStepStatus.OFFERED,
                    name: BPMCaseStep_1.BPMCaseStep.WaitForInstallation,
                    segment: base_models_1.SegmentType.HH,
                },
            ],
            caseData: {
                emobilityId: '12345',
                accountId: '0123456789',
                state: 'WAITFORDATACOLLECTION',
            },
        },
        description: 'Reimbursement steps. Only include if there is reimbursement case available.',
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Type)(() => BpmRunningCaseData),
    tslib_1.__metadata("design:type", BpmRunningCaseData)
], EmobilityOnBoardingCasesResponse.prototype, "reimbursement", void 0);
tslib_1.__decorate([
    (0, base_models_1.Docs)({
        example: {
            steps: [
                {
                    caseId: 12,
                    startDate: '2022-01-25T12:39:50.528Z',
                    targetDate: '2022-01-25T12:39:50.528Z',
                    lastUpdate: '2022-01-25T12:39:50.528Z',
                    completionDate: '2022-01-25T12:39:50.528Z',
                    status: BPMStepStatus_1.BPMStepStatus.OFFERED,
                    name: BPMCaseStep_1.BPMCaseStep.WaitForInstallation,
                    segment: base_models_1.SegmentType.HH,
                },
            ],
            caseData: {
                emobilityId: '12345',
                accountId: '0123456789',
                state: 'WAITFORDATACOLLECTION',
            },
        },
        description: 'All charge station steps. Only include if there are charge station steps available.',
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Type)(() => BpmRunningCaseData),
    tslib_1.__metadata("design:type", BpmRunningCaseData)
], EmobilityOnBoardingCasesResponse.prototype, "chargeStation", void 0);
